import axios from "axios"

export default {
    state : {
        galleries : []
    },
    getters : {
        galleries(state) {
            return state.galleries;
        }
    },
    mutations : {
        setGalleries(state, galleries) {
            state.galleries = galleries;
        }
    },
    actions : {
       async getGalleries({commit}) {
          let res =  await axios.get(`/photo_galleries`);
          let galleries = res.data.data;
          commit('setGalleries', galleries)
       } 
    }
}